<template>
<div :class="computedReadOnly ? 'disablebg': ''">
  <PopupDetails
    :readOnly="computedReadOnly"
    :isFirstColumn="isFirstColumn"
    :header="header"
    :details = "details"
    :value="details && details[header.column]"
    :material="materialPce"
    :quantity="quantity"
    :weight="weight"
    :originalMaterialSummary="originalMaterialSummary"
    :mrp="mrp"
    :showAmount="showAmount"
    :unit="materialCategory && header.unit && materialCategory[header.unit]"
    @updateValues="updateValues"
    @updateAmount="updateAmount" />
</div>
</template>

<script>
import { mapGetters } from 'vuex';
import { movementMap } from 'pando-constants';
import PopupDetails from './PopupDetails';

export default {
  props: ['header', 'index', 'details', 'material', 'quantity', 'weight', 'materialCategory',
    'readOnly', 'materialId', 'isFirstColumn', 'pce_box', 'volume_per_piece', 'mrp', 'movement', 'originalMaterialSummary'],
  components: {
    PopupDetails,
  },
  computed: {
    materialPce() {
      return { ...this.material, pce_box: this.pce_box, volume_per_piece: this.volume_per_piece };
    },
    ...mapGetters({
      configurations: 'app/currentClientConfig',
    }),
    computedReadOnly() {
      // If header has a permission property, check if user has that permission
      if (this.header.permission) {
        // If user has the permission, make it editable (readOnly = false)
        if (this.$hasPermission(this.header.permission)) {
          return false;
        }
        // If user doesn't have the permission, make it readOnly
        return true;
      }
      // For headers without permission property, use the original readOnly prop
      return this.readOnly;
    },
    showAmount() {
      const movement = movementMap[this.movement].toLowerCase();
      const paymentStrategies = this.configurations && this.configurations.payment_strategies;
      const sdcdConfig = paymentStrategies && paymentStrategies.movement_based[movement];
      return sdcdConfig[this.header.name] && sdcdConfig[this.header.name].amount_type === 4;
    },
  },
  methods: {
    updateValues(value) {
      this.details[this.header.column] = value;
      this.$emit('markAsModified', this.materialId);
      this.$store.commit('indents/hasWarnedOnce', false);
    },
    updateAmount(value) {
      this.details[this.header.charge] = value;
      this.$emit('markAsModified', this.materialId);
    },
  },
};
</script>
